import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify'; 
import { AmplifyService } from 'aws-amplify-angular'; 
import { scaleIn } from '../../shared/animations/modal.animation';

@Component({
  selector: 'app-sponsors-register',
  templateUrl: './sponsors-register.component.html',
  styleUrls: ['./sponsors-register.component.css'], 
  providers: [AmplifyService], 
  animations: [scaleIn]
})
export class SponsorsRegisterComponent implements OnInit {

  @Input() visible: boolean; 
  sponsorsRegisterForm: FormGroup
  isLoading: boolean;
  errMessage: any;
  emailErr: any;
  usernameErr: any;
  passwordErr: any;
  passwrdNotMatchErr: any;
  user: import("amazon-cognito-identity-js").ISignUpResult;
  passwordStrengthErr: any;
  public showConfFields: boolean; 

  constructor(private fb: FormBuilder, private router: Router, private amplifyService: AmplifyService) {
    this.sponsorsRegisterForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confPassword: ['', [Validators.required]],
      cellphone: ['', [Validators.required]],
      code: ['', [Validators.required]]
    })
  }

  ngOnInit(): void {
  }

  submit() {
    //Submit method in here...
  }

  async SignUp(username, email, password, confirmPassword, family_name, name) {
    this.isLoading = true;
    if (email === '') {
      this.isLoading = false;
      this.errMessage = this.emailErr;
    }
    else if (username === "") {
      this.isLoading = false; 
      this.errMessage = this.usernameErr; 
    }
    else if (password === "") {
      this.isLoading = false; 
      this.errMessage = this.passwordErr; 
    }
    else if (password !== confirmPassword) {
      this.isLoading = false; 
      this.errMessage = this.passwrdNotMatchErr; 
    }

    else {
      Auth.signUp({
        username, 
        password, 
        attributes: {
          email, 
          family_name, 
          name
        }
      })
      .then((data) => {
        this.user = data; 
        console.log('User Data => ', data); 
        this.isLoading = false; 
      })
      .catch(err => {

        this.isLoading = false;
        // if (err.message.includes("validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6") ||
        //   err.message.includes("Password did not conform with policy: Password not long enough")) {
        //   this.errMessage = this.passwordStrengthErr;
        // }
        // else {
        //   this.errMessage = err.message;
        // }
        console.log("Error: " + err.message);


      });
      
    }
  }

  confirmSignUp() {
    //Method
  }

  close() {
    this.visible = false; 
  }

}
